import { render, staticRenderFns } from "./m_picworksInfo.vue?vue&type=template&id=85caf62a&scoped=true&"
import script from "./m_picworksInfo.vue?vue&type=script&lang=js&"
export * from "./m_picworksInfo.vue?vue&type=script&lang=js&"
import style0 from "./m_picworksInfo.vue?vue&type=style&index=0&id=85caf62a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85caf62a",
  null
  
)

export default component.exports